<!-- <ng-container *ngIf="displayType === 'list'">
    <app-custom-objects-list-type-molecule [config]="customObj"></app-custom-objects-list-type-molecule>
</ng-container> -->

<ng-container *ngIf="displayType === 'object'; else listTypeTemplate">
    <app-custom-objects-object-type-molecule [config]="customObj"></app-custom-objects-object-type-molecule>
</ng-container>
<ng-template #listTypeTemplate>
    <app-custom-objects-list-type-molecule [config]="customObj"></app-custom-objects-list-type-molecule>
</ng-template>